module.exports = __webpack_public_path__ + "img/private-cloud.44e05ae.svg";